import React from "react";
import tw, { styled } from "twin.macro";
import GoogleLogin from "react-google-login";
import google from "../../assets/svg/google.svg";

const BtnGoogle = styled.button`
	${tw`w-full! border border-transparent rounded-2xl! px-3 py-3 bg-white! hover:cursor-pointer text-appTextDark! flex! flex-row flex-nowrap items-center justify-center shadow text-sm opacity-100 hover:opacity-80`}
	span {
		${tw`pr-2!`}
	}
`;

const GoogleAuth = (props) => {
	const responseGoogle = () => {
		console.log("google login");
	};
	const responseGoogleError = () => {
		console.log("google login");
	};
	return (
		<>
			<GoogleLogin
				clientId={
					"658977310896-knrl3gka66fldh83dao2rhgbblmd4un9.apps.googleusercontent.com"
				}
				icon={true}
				onSuccess={responseGoogle}
				onFailure={responseGoogleError}
				cookiePolicy={"single_host_origin"}
				render={(renderProps) => (
					<BtnGoogle
						onClick={renderProps.onClick}
						disabled={renderProps.disabled}
					>
						<span>
							<img src={google} alt="" width="20px" height="auto" tw="mr-3!" />
						</span>

						{renderProps.disabled ? (
							<span tw="opacity-60">Initializing, Please wait...</span>
						) : (
							<span> Google</span>
						)}
					</BtnGoogle>
				)}
			/>
		</>
	);
};

export default GoogleAuth;
